import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import useAuth from "../../hooks/useAuth";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useParams } from "react-router-dom"; // Import useParams from react-router-dom
import 'boxicons/css/boxicons.min.css';
import "./Admin.css";
import TopBar from "./TopBar";

const ManifestDetails = () => {
  const { auth } = useAuth();
  const { manifestNumber } = useParams(); // Get the employeeId from the URL
  const GETMANIFEST_URL = "api/get-manifest";
  const axiosPrivate = useAxiosPrivate();
  const [manifests, setManifests] = useState([]); // To store list of users
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const headers = {
        "Content-Type": "application/json",
      };
      const data = {
        manifest_number: manifestNumber,
      };

      try {

        const response = await axiosPrivate.get(GETMANIFEST_URL, {
          params: data,
          headers,
          withCredentials: true, // Ensures cookies are sent with the request if needed
        });

        setManifests(response.data); // Store the fetched data into the user state
        setLoading(false); // Stop loading spinner
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to load data");
        setLoading(false); // Set loading to false even if there is an error
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <>
      
      <section className="bookbody">
        <br />
        <div className="wrapperbook">
          {/* <center><img src="/images/box.png" width="15%" className='adm-img' /></center> */}
          <h3>Manifest Details</h3>

          <Row>
                                      <Col>
                                    <p><span className="empspan">Manifest Id :</span> {manifests.manifest_id}</p>
                                    </Col>
                                    <Col>
                                    <p><span className="empspan">Franchise Id :</span> {manifests.franchise_id}</p>
                                    </Col>
                                    </Row>
                                    <Row>
                                      <Col>
                                    <p><span className="empspan">Manifest Date :</span> {manifests.manifest_date}</p>
                                    </Col>
                                    <Col>
                                    <p><span className="empspan">Franchise Number :</span> {manifests.manifest_number}</p>
                                    </Col>
                                    </Row>
                                    <Row>
                                      <Col>
                                    <p><span className="empspan">Manifest Destination Id :</span> {manifests.manifest_destination_id}</p>
                                    </Col>
                                    <Col>
                                    <p><span className="empspan">Destination Franchise Code :</span> {manifests.manifest_number}</p>
                                    </Col>
                                    </Row>
                                    <Row>
                                      <Col>
                                    <p><span className="empspan">Franchise Name :</span> {manifests.manifest_destination_franchise_name}</p>
                                    </Col>
                                    <Col>
                                    <p><span className="empspan">Total Consignments :</span> {manifests.total_consignments}</p>
                                    </Col>
                                    </Row>
                                    <Row>
                                      <Col>
                                    <p><span className="empspan">Weight :</span> {manifests.weight}</p>
                                    </Col>
                                    <Col>
                                    <p><span className="empspan">Current Status :</span> {manifests.current_status}</p>
                                    </Col>
                                    </Row>

        </div>
      </section>

      <section className="mantabbody">
        <br />
        <div className="wrapper7 ">
          <table border="1" id="customers">
            <thead>
              <tr>
                <th>Consignment Id</th>
                <th>Awb Number</th>
                <th>Destination Franchise Id</th>
                <th>Destination Franchise Code</th>
                <th>Destination Franchise</th>
              </tr>
            </thead>
            <tbody>
              {manifests.consignments.map((consignment) => (
                <tr key={consignment.consignment_id}>
                  <td>{consignment.consignment_id}</td>
                  <td>{consignment.awb_number}</td>
                  <td>{consignment.consignment_destination_franchise_id}</td>
                  <td>{consignment.consignment_destination_franchise_code}</td>
                  <td>{consignment.consignment_destination_franchise}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
      <TopBar />
    </>
  );
};

export default ManifestDetails;
